/**
 * 用户 | 用户规则 | 管理员 | 权限
 */
import Net from '../net';

const NAME = '[UserApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === User === **/
/** user/login
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.password
*/
export async function loginUser(data = {}) {
  Log('loginUser data:', data)
  try {
    const res = await Net.http('user/login', { data })
    Log('loginUser res:', res)
    return res
  } catch (err) {
    Log('loginUser err:', err)
    throw err
  }
}

/** operator/login
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.password
*/
export async function userOperatorLogin(data = {}) {
  Log('userOperatorLogin data:', data)
  try {
    const res = await Net.http('operator/login', { data })
    Log('userOperatorLogin res:', res)
    return res
  } catch (err) {
    Log('userOperatorLogin err:', err)
    throw err
  }
}

/** clearing-account/login
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.password
*/
export async function userSettlementLogin(data = {}) {
  Log('userSettlementLogin data:', data)
  try {
    const res = await Net.http('clearing-account/login', { data })
    Log('userSettlementLogin res:', res)
    return res
  } catch (err) {
    Log('userSettlementLogin err:', err)
    throw err
  }
}

/** user/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.nickname
 * @param {*} data.page
 * @param {*} data.phone
*/
export async function getUserList(data = {}) {
  Log('getUserList data:', data)
  try {
    const res = await Net.http('user/list', { data })
    Log('getUserList res:', res)
    return res
  } catch (err) {
    Log('getUserList err:', err)
    throw err
  }
}

/** user/detail-by-phone
 * @param {Object} data
 * @param {*} data.phone
*/
export async function getUserDetailByPhone(data = {}) {
  Log('getUserDetailByPhone data:', data)
  try {
    const res = await Net.http('user/detail-by-phone', { data })
    Log('getUserDetailByPhone res:', res)
    return res
  } catch (err) {
    Log('getUserDetailByPhone err:', err)
    throw err
  }
}

/** user/list
 * @param {Object} data
 * @param {*} data.phone
*/
export async function getUserListByPhone(data = {}) {
  Log('getUserListByPhone data:', data)
  try {
    const res = await Net.http('user/list', { data })
    Log('getUserListByPhone res:', res)
    return res
  } catch (err) {
    Log('getUserListByPhone err:', err)
    throw err
  }
}

/** user/find-user
 * @param {Object} data
 * @param {*} data.user_id
*/
export async function getUserDetail(data = {}) {
  Log('getUserDetail data:', data)
  try {
    const res = await Net.http('user/find-user', { data })
    Log('getUserDetail res:', res)
    return res
  } catch (err) {
    Log('getUserDetail err:', err)
    throw err
  }
}

/** user/delete-user
 * @param {Object} data
 * @param {*} data.user_id
*/
export async function deleteUser(data = {}) {
  Log('deleteUser data:', data)
  try {
    const res = await Net.http('user/delete-user', { data })
    Log('deleteUser res:', res)
    return res
  } catch (err) {
    Log('deleteUser err:', err)
    throw err
  }
}

/** user/create
 * @param {Object} data
 * @param {*} data.phone
*/
export async function createUser(data = {}) {
  Log('createUser data:', data)
  try {
    const res = await Net.http('user/create', { data })
    Log('createUser res:', res)
    return res
  } catch (err) {
    Log('createUser err:', err)
    throw err
  }
}

/** order/list
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.page
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function userOrderList(data = {}) {
  Log('userOrderList data:', data)
  try {
    const res = await Net.http('order/list', { data })
    Log('userOrderList res:', res)
    return res
  } catch (err) {
    Log('userOrderList err:', err)
    throw err
  }
}

/** virtual-card/list
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.page
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function userVirtualCardList(data = {}) {
  Log('userVirtualCardList data:', data)
  try {
    const res = await Net.http('virtual-card/list', { data })
    Log('userVirtualCardList res:', res)
    return res
  } catch (err) {
    Log('userVirtualCardList err:', err)
    throw err
  }
}


/** === UserRule === **/
/** user-rule/list
 * @param {Object} data
 * @param {*} data.phone
 * @param {*} data.name
 * @param {*} data.mode
 * @param {*} data.page
*/
export async function getUserRuleList(data = {}) {
  Log('getUserRuleList data:', data)
  try {
    const res = await Net.http('user-rule/list', { data })
    Log('getUserRuleList res:', res)
    return res
  } catch (err) {
    Log('getUserRuleList err:', err)
    throw err
  }
}

/** user-rule/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteUserRule(data = {}) {
  Log('deleteUserRule data:', data)
  try {
    const res = await Net.http('user-rule/delete', { data })
    Log('deleteUserRule res:', res)
    return res
  } catch (err) {
    Log('deleteUserRule err:', err)
    throw err
  }
}

/** user-rule/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.phone
 * @param {*} data.name
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.mode
 * @param {*} data.config
*/
export async function saveUserRule(data = {}) {
  Log('saveUserRule data:', data)
  try {
    const res = await Net.http('user-rule/save', { data })
    Log('saveUserRule res:', res)
    return res
  } catch (err) {
    Log('saveUserRule err:', err)
    throw err
  }
}

/** user-rule/find-by-phone
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.user_id
*/
export async function findUserRuleByPhone(data = {}) {
  Log('findUserRuleByPhone data:', data)
  try {
    const res = await Net.http('user-rule/find-by-phone', { data })
    Log('findUserRuleByPhone res:', res)
    return res
  } catch (err) {
    Log('findUserRuleByPhone err:', err)
    throw err
  }
}

/** user-rule/update-username
 * @param {Object} data
 * @param {*} data.phone
 * @param {*} data.org_id
 * @param {*} data.username
*/
export async function updateUserRuleUsername(data = {}) {
  Log('updateUserRuleUsername data:', data)
  try {
    const res = await Net.http('user-rule/update-username', { data })
    Log('updateUserRuleUsername res:', res)
    return res
  } catch (err) {
    Log('updateUserRuleUsername err:', err)
    throw err
  }
}

/** user-rule/delete-batch
 * @param {Object} data
 * @param {*} data.ids
*/
export async function deleteUserRuleBatch(data = {}) {
  Log('deleteUserRuleBatch data:', data)
  try {
    const res = await Net.http('user-rule/delete-batch', { data })
    Log('deleteUserRuleBatch res:', res)
    return res
  } catch (err) {
    Log('deleteUserRuleBatch err:', err)
    throw err
  }
}

/** user-rule/update-batch
 * @param {Object} data
 * @param {*} data.ids
 * @param {*} data.mode
 * @param {*} data.config
 * @param {*} data.free_time
 * @param {*} data.flag_car_user_rule
 * @param {*} data.flag_user_rule
*/
export async function batchUpdateUserRule(data = {}) {
  Log('batchUpdateUserRule data:', data)
  try {
    const res = await Net.http('user-rule/update-batch', { data })
    Log('batchUpdateUserRule res:', res)
    return res
  } catch (err) {
    Log('batchUpdateUserRule err:', err)
    throw err
  }
}


/** === UserRuleLog === **/
/** user-rule-log/list
 * @param {Object} data
 * @param {*} data.phone
 * @param {*} data.page
*/
export async function getUserRuleLogList(data = {}) {
  Log('getUserRuleLogList data:', data)
  try {
    const res = await Net.http('user-rule-log/list', { data })
    Log('getUserRuleLogList res:', res)
    return res
  } catch (err) {
    Log('getUserRuleLogList err:', err)
    throw err
  }
}


/** === Admin === **/
/** admin/register
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.password
*/
export async function adminRegister(data = {}) {
  Log('adminRegister data:', data)
  try {
    const res = await Net.http('admin/register', { data })
    Log('adminRegister res:', res)
    return res
  } catch (err) {
    Log('adminRegister err:', err)
    throw err
  }
}

/** admin/list
 * @param {Object} data
 * @param {*} data.page
*/
export async function getAdminList(data = {}) {
  Log('getAdminList data:', data)
  try {
    const res = await Net.http('admin/list', { data })
    Log('getAdminList res:', res)
    return res
  } catch (err) {
    Log('getAdminList err:', err)
    throw err
  }
}

/** admin/detail
 * @param {Object} data
 * @param {*} data.admin_id
*/
export async function getAdminDetail(data = {}) {
  Log('getAdminDetail data:', data)
  try {
    const res = await Net.http('admin/detail', { data })
    Log('getAdminDetail res:', res)
    return res
  } catch (err) {
    Log('getAdminDetail err:', err)
    throw err
  }
}

/** admin/delete
 * @param {Object} data
 * @param {*} data.admin_id
*/
export async function deleteAdmin(data = {}) {
  Log('deleteAdmin data:', data)
  try {
    const res = await Net.http('admin/delete', { data })
    Log('deleteAdmin res:', res)
    return res
  } catch (err) {
    Log('deleteAdmin err:', err)
    throw err
  }
}

/** admin/get-admin-action
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.user_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function adminActionList(data = {}) {
  Log('adminActionList data:', data)
  try {
    const res = await Net.http('admin/get-admin-action', { data })
    Log('adminActionList res:', res)
    return res
  } catch (err) {
    Log('adminActionList err:', err)
    throw err
  }
}

/** admin/update-password
 * @param {Object} data
 * @param {*} data.admin_id
 * @param {*} data.old_password
 * @param {*} data.new_password
*/
export async function updateAdminPassword(data = {}) {
  Log('updateAdminPassword data:', data)
  try {
    const res = await Net.http('admin/update-password', { data })
    Log('updateAdminPassword res:', res)
    return res
  } catch (err) {
    Log('updateAdminPassword err:', err)
    throw err
  }
}

/** admin/update-member-password
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.new_password
*/
export async function resetAdminPassword(data = {}) {
  Log('resetAdminPassword data:', data)
  try {
    const res = await Net.http('admin/update-member-password', { data })
    Log('resetAdminPassword res:', res)
    return res
  } catch (err) {
    Log('resetAdminPassword err:', err)
    throw err
  }
}

/** operator/set-user-bind-phone
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.flag_force_bind_phone
*/
export async function setAdminUserBindPhone(data = {}) {
  Log('setAdminUserBindPhone data:', data)
  try {
    const res = await Net.http('operator/set-user-bind-phone', { data })
    Log('setAdminUserBindPhone res:', res)
    return res
  } catch (err) {
    Log('setAdminUserBindPhone err:', err)
    throw err
  }
}


/** === Authority === **/
/** authority/list-by-user
 * @param {Object} data
*/
export async function getAuthorityListByUser(data = {}) {
  Log('getAuthorityListByUser data:', data)
  try {
    const res = await Net.http('authority/list-by-user', { data })
    Log('getAuthorityListByUser res:', res)
    return res
  } catch (err) {
    Log('getAuthorityListByUser err:', err)
    throw err
  }
}

/** authority/list-by-role
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.user_type
 * @param {*} data.purpose
*/
export async function getAuthorityListByRole(data = {}) {
  Log('getAuthorityListByRole data:', data)
  try {
    const res = await Net.http('authority/list-by-role', { data })
    Log('getAuthorityListByRole res:', res)
    return res
  } catch (err) {
    Log('getAuthorityListByRole err:', err)
    throw err
  }
}

/** authority/list-by-user-role
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.user_type
*/
export async function getAuthorityListByUserRole(data = {}) {
  Log('getAuthorityListByUserRole data:', data)
  try {
    const res = await Net.http('authority/list-by-user-role', { data })
    Log('getAuthorityListByUserRole res:', res)
    return res
  } catch (err) {
    Log('getAuthorityListByUserRole err:', err)
    throw err
  }
}

/** authority/role/list
 * @param {Object} data
*/
export async function authorityRoleList(data = {}) {
  Log('authorityRoleList data:', data)
  try {
    const res = await Net.http('authority/role/list', { data })
    Log('authorityRoleList res:', res)
    return res
  } catch (err) {
    Log('authorityRoleList err:', err)
    throw err
  }
}

/** authority/role/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.key
 * @param {*} data.name
*/
export async function saveAuthorityRole(data = {}) {
  Log('saveAuthorityRole data:', data)
  try {
    const res = await Net.http('authority/role/save', { data })
    Log('saveAuthorityRole res:', res)
    return res
  } catch (err) {
    Log('saveAuthorityRole err:', err)
    throw err
  }
}

/** authority/role-authority/save
 * @param {Object} data
 * @param {*} data.role_id
 * @param {*} data.authority_ids
*/
export async function saveAuthorityRoleAuthority(data = {}) {
  Log('saveAuthorityRoleAuthority data:', data)
  try {
    const res = await Net.http('authority/role-authority/save', { data })
    Log('saveAuthorityRoleAuthority res:', res)
    return res
  } catch (err) {
    Log('saveAuthorityRoleAuthority err:', err)
    throw err
  }
}

/** authority/user-authority/save
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.user_type
 * @param {*} data.authority_ids
*/
export async function saveAuthorityUserAuthority(data = {}) {
  Log('saveAuthorityUserAuthority data:', data)
  try {
    const res = await Net.http('authority/user-authority/save', { data })
    Log('saveAuthorityUserAuthority res:', res)
    return res
  } catch (err) {
    Log('saveAuthorityUserAuthority err:', err)
    throw err
  }
}

/** authority/role/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteAuthorityRole(data = {}) {
  Log('deleteAuthorityRole data:', data)
  try {
    const res = await Net.http('authority/role/delete', { data })
    Log('deleteAuthorityRole res:', res)
    return res
  } catch (err) {
    Log('deleteAuthorityRole err:', err)
    throw err
  }
}
